import React from "react";
import { useNavigate } from "react-router-dom";
import CustomTable from "../../../components/CustomTable/CustomTable";
import { Button, Label, Input } from "reactstrap";
import { t } from "i18next";
import { usePagination } from "../../../hooks/usePagination";
import PaginationHandler from "../../../components/PaginationHandler";
import { getLeadContacts, deleteLeadContact } from "../../../api/leadContacts";
import Breadcrumbs from "../../../components/Common/Breadcrumb";

export default function LeadContactData({ leadId }) {
    const navigate = useNavigate();
    console.log(leadId);
    const currentUser = JSON.parse(localStorage.getItem("currentUser")) || {};
    const role = currentUser.role || currentUser.roleName || {};
    const hasPermission = (action) => {
        if (role.name === "super admin") return true;
        return (
            role.permissions &&
            role.permissions.some(
                (perm) => perm.resource === "Sales" && perm.actions.includes(action)
            )
        );
    };
    localStorage.setItem("leadContactId", leadId);
    const canCreate = () => hasPermission("create");
    const canEdit = () => hasPermission("update");
    const canDelete = () => hasPermission("delete");
    const canRead = () => hasPermission("read") || hasPermission("delete") || hasPermission("update");

    const {
        response,
        loading,
        error,
        setPage,
        page,
        totalPages,
        setMeta,
    } = usePagination(getLeadContacts, { leadId, sort: "-createdAt" }, Boolean(leadId));


    const [typeFilter, setTypeFilter] = React.useState("");

    const handleFilter = () => {
        setMeta((meta) => ({
            ...meta,
            page: 1,
            payload: {
                leadId,
                type: typeFilter || undefined,
                sort: "-createdAt"
            },
        }));
    };

    const handleDelete = async (id) => {
        if (window.confirm(t("Are you sure you want to delete this Lead Contact?"))) {
            try {
                await deleteLeadContact(id);
                setPage(1);
            } catch (err) {
                console.error("Delete failed:", err);
                alert(t("Failed to delete Lead Contact."));
            }
        }
    };

    if (!canRead()) {
        return <div>{t("You do not have permission to view lead contacts.")}</div>;
    }

    return (
        <div className="mt-4">
            <Breadcrumbs
                title={t("Lead Contacts")}
                addUrl={canCreate() ? "/lead-contacts/add" : null}
                hasAddBtn={canCreate()}
                isMainPage={true}
            />

            {/* Optional filter by type */}
            {/* <div className="d-flex align-items-center mb-3" style={{ gap: 15 }}>
                <Label>{t("Type")}</Label>
                <Input
                    type="text"
                    value={typeFilter}
                    onChange={(e) => setTypeFilter(e.target.value)}
                    placeholder={t("Filter by type")}
                    style={{ maxWidth: 200 }}
                />
                <Button color="primary" onClick={handleFilter}>
                    {t("Search")}
                </Button>
            </div> */}

            {response && response.length > 0 && !loading ? (
                <>
                    <CustomTable
                        emptyMsg={t("No Lead Contacts Found.")}
                        data={response}
                        loading={loading}
                        error={error}
                        cols={[
                            {
                                label: t("Lead Email"),
                                key: "leadEmail",
                                style: { width: "25%" },
                                renderer: (row) => <>{row.leadId?.email || "—"}</>,
                            },
                            {
                                label: t("Type"),
                                key: "type",
                                style: { width: "15%" },
                            },
                            {
                                label: t("Notes"),
                                key: "notes",
                                style: { width: "15%" },
                            },
                            {
                                label: t("Potential Budget"),
                                key: "potentialBudget",
                                style: { width: "15%" },
                                renderer: (row) =>
                                    row.potentialBudget !== undefined && row.potentialBudget !== null
                                        ? `${Number(row.potentialBudget).toLocaleString()} EGP`
                                        : "N/A",
                            },

                            {
                                label: t("Status"),
                                key: "statusLeadContactId",
                                style: { width: "15%" },
                                renderer: (row) => <>{row.statusLeadContactId?.name || "—"}</>,
                            },
                            {
                                label: t("Actions"),
                                key: "actions",
                                style: { width: "15%" },
                                renderer: (row) => (
                                    <div className="d-flex gap-2">
                                        {canEdit() && (
                                            <Button
                                                color="info"
                                                size="sm"
                                                onClick={() =>
                                                    navigate(`/lead-contacts/edit/${row._id}`)
                                                }
                                            >
                                                {t("Edit")}
                                            </Button>
                                        )}
                                        {canDelete() && (
                                            <Button
                                                color="danger"
                                                size="sm"
                                                onClick={() => handleDelete(row._id)}
                                            >
                                                {t("Delete")}
                                            </Button>
                                        )}
                                    </div>
                                ),
                            },
                        ]}
                    />

                    <PaginationHandler page={page} setPage={setPage} totalPages={totalPages} />
                </>
            ) : (
                !loading && <div>{t("No results found.")}</div>
            )}
        </div>
    );
}
